import request from './request';

const bannerService = {
  getAll: (params) =>
    request.get('dashboard/admin/bloggers/paginate', { params }),
  getById: (id, params) =>
    request.get(`dashboard/admin/bloggers/${id}`, { params }),
  create: (params) => request.post('dashboard/admin/bloggers', {}, { params }),
  update: (id, params) =>
    request.put(`dashboard/admin/bloggers/${id}`, {}, { params }),
  delete: (id) => request.delete(`dashboard/admin/bloggers/${id}`),
  setActive: (id) => request.post(`dashboard/admin/bloggers/active/${id}`),
};

export default bannerService;
